import React, { ReactNode } from "react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { StyledTextWrapper, StyledText } from "./partials"

export interface TextProps {
  copy: string
}

export const TextCmp: React.FC<TextProps> = ({ copy }) => (
  <StyledTextWrapper>
    {copy && (
      <StyledText>
        {
          unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeReact as any, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment
            })
            .processSync(copy.replace(/\n/g, "  \n")).result as ReactNode
        }
      </StyledText>
    )}
  </StyledTextWrapper>
)

export default TextCmp
